import isEmpty from 'lodash/isEmpty';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useMediaQuery } from 'react-responsive';
import WidgetBylines from 'src/components/widgets/widget-bylines';
// import StickyBox from 'react-sticky-box';
// import Carousels from 'src/components/carousels';
import { APP_IMG, SHOW_COMMEMORATE } from 'src/constants';
import { KEY_ADS_POSITION } from 'src/utils/ads/dynamic-ads';
// import DynamicAds, { KEY_ADS_POSITION } from 'src/utils/ads/dynamic-ads';
import { getAffiliate } from 'src/utils/contents/get-affiliate';
import { getFeatureImage } from 'src/utils/contents/get-image';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import useResponsive from 'src/utils/devices';
import { arrayEmpty } from 'src/utils/helper';
import styled from 'styled-components';
// import WidgetBreadcrumb from 'src/2.0/widgets/widget-breadcrumb';

const StickyBox = dynamic(() => import('react-sticky-box'), { ssr: true });
const Carousels = dynamic(() => import('src/components/carousels'), { ssr: false });
const DynamicAds = dynamic(() => import('src/utils/ads/dynamic-ads'), { ssr: true });

const CardH = dynamic(import('src/components/cards/card-h'), { ssr: true });
const AdsNative = dynamic(import('src/components/ads/ads-native'), { ssr: false });
const WidgetBreadcrumb = dynamic(import('src/2.0/widgets/widget-breadcrumb'), { ssr: true });
const WidgetHeading = dynamic(import('src/2.0/widgets/widget-heading'), { ssr: false });
const WidgetKeypoint = dynamic(import('src/2.0/widgets/widget-keypoint'), { ssr: true });
const WidgetMetaContent = dynamic(import('src/2.0/widgets/widget-meta-content'), { ssr: false });
const WidgetTags = dynamic(import('src/2.0/widgets/widget-tags'), { ssr: true });
const WidgetByline = dynamic(() => import('src/2.0/widgets/widget-byline'));

const ArticleDefault = ({ translated, isKeyPoint, article, ads, dataAffiliate, lastNews, dataAdsNative, related }) => {
  const router = useRouter();
  const responsive = useResponsive();
  const { isMobile } = useResponsive();
  function generateAdConfig(position, dataArray) {
    // หาตำแหน่งข้อมูลที่ match กับ position
    const foundItem = dataArray?.find(item => item?.position === position);

    // ถ้าเจอ item ใช้ otherScript แทน body ไม่งั้นใช้ defaultBody
    const bodyContent = foundItem?.otherScript || '';

    return bodyContent;
  }

  const isMb = useMediaQuery({ query: '(max-width: 768px)' });
  // console.log('native-below-article-mobile :', generateAdConfig('native-below-article-mobile', ads), !isMobile, dataAdsNative);
  return (
    <SectionWrapper>
      <div className='container'>
        <div className='article-wrapper'>
          <div className='block-1'>
            <WidgetBreadcrumb article={article} />
            {/* Responsive ผ่าน CSS แทน JS เพื่อให้ HTML ฝั่ง server/client ตรงกัน ป้องกัน layout สลับหลัง hydration (CLS) */}
            <div className='hight-widget-meta-content desktop-only' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
              <WidgetMetaContent article={article} />
            </div>
            <h1 className='article-title' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
              {' '}
              {article.title}{' '}
            </h1>
            {/* Byline: responsive ผ่าน CSS แทน JS isMobile เพื่อให้ HTML server/client ตรงกัน ป้องกัน layout สลับหลัง hydration (CLS) */}
            <div className='desktop-only'>
              <WidgetBylines
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'Byline',
                  position: 'ใต้:รูปหลัก'
                }}
                article={article}
              />
            </div>
            <div className='card-feature'>
              {getFeatureImage(article, false, true)} {/* เพิ่ม priority=true สำหรับรูปหลัก */}
              <div className='mobile-only'>
                <WidgetBylines
                  eventDataLayer={{
                    type: DATALAYER_TYPE.TRACK_POSITION,
                    router: router?.pathname,
                    section: 'Byline',
                    position: 'ใต้:รูปหลัก'
                  }}
                  article={article}
                />
              </div>
              {translated}
              <div className='hight-widget-meta-content-mb mobile-only' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
                <WidgetMetaContent article={article} showByline={false} />
              </div>
            </div>
            <div id='content' className='content-wrapper'>
              {isEmpty(article.key_point) && article?.blurb !== '' && (
                <h2 className='content-blurb' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
                  <blockquote dangerouslySetInnerHTML={{ __html: article?.blurb }} />
                </h2>
              )}
              {!isEmpty(article.key_point) && <WidgetKeypoint isKeyPoint={isKeyPoint} article={article} style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }} />}
              <div id='paragraph'>
                {/* ---------------------------- INARTICLE-2 ----------------------------- */}
                {article?.content_I && (
                  <>
                    {article?.is_creden ? (
                      <div
                        id='paragraph-1'
                        data-news-content='company'
                        style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}
                        className='content-detail'
                        dangerouslySetInnerHTML={{
                          __html: article?.content_I
                        }}
                      />
                    ) : (
                      <div
                        id='paragraph-1'
                        className='content-detail'
                        style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}
                        dangerouslySetInnerHTML={{
                          __html: article?.content_I
                        }}
                      />
                    )}
                    {article?.is_show_ads && getAffiliate(1, dataAffiliate)}
                    {article?.is_show_ads && !isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_1} data={ads} />}
                  </>
                )}

                {/* ---------------------------- INARTICLE-2 ----------------------------- */}
                {article?.content_II && (
                  <>
                    {article?.is_creden ? (
                      <div
                        id='paragraph-2'
                        data-news-content='company'
                        className='content-detail'
                        style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}
                        dangerouslySetInnerHTML={{
                          __html: article?.content_II
                        }}
                      />
                    ) : (
                      <div
                        id='paragraph-2'
                        className='content-detail'
                        style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}
                        dangerouslySetInnerHTML={{
                          __html: article?.content_II
                        }}
                      />
                    )}
                    {article?.is_show_ads && getAffiliate(2, dataAffiliate)}
                    {article?.is_show_ads && !isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_2} data={ads} />}
                  </>
                )}

                {!generateAdConfig('native-in-article-related', ads) ? (
                  <>
                    {!isEmpty(related) && (
                      <div className='widget-content related-news-desktop' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
                        <div className='widget-content-title'>
                          <div className='related-news fw-500'>เนื้อหาที่เกี่ยวข้อง</div>
                        </div>
                        <div className='block-content'>
                          <ul className='block-list'>
                            {related.slice(0, 3).map((item, index) => (
                              <li key={index}>
                                <CardH
                                  data={item}
                                  large={false}
                                  external={false}
                                  loading='lazy'
                                  //! DATALAYER
                                  eventDataLayer={{
                                    type: DATALAYER_TYPE.TRACK_POSITION,
                                    router: router?.pathname,
                                    section: 'เนื้อหาที่เกี่ยวข้อง',
                                    position: 'ใต้:paragraph-2',
                                    data: {
                                      block: '1',
                                      title: item?.title,
                                      heading: 'เนื้อหาที่เกี่ยวข้อง',
                                      index: index + 1
                                    }
                                  }}
                                />
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {article?.is_show_ads && !isEmpty(ads) && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: generateAdConfig('native-in-article-related', ads)
                        }}
                      />
                    )}
                  </>
                )}

                {/* ---------------------------- INARTICLE-3 ----------------------------- */}
                {article?.content_III && (
                  <>
                    {article?.is_show_ads && !isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_3} data={ads} />}

                    {article?.is_creden ? (
                      <div
                        id='paragraph-3'
                        data-news-content='company'
                        className='content-detail'
                        style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}
                        dangerouslySetInnerHTML={{
                          __html: article?.content_III
                        }}
                      />
                    ) : (
                      <div
                        id='paragraph-3'
                        className='content-detail'
                        style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}
                        dangerouslySetInnerHTML={{
                          __html: article?.content_III
                        }}
                      />
                    )}
                    {article?.is_show_ads && getAffiliate(3, dataAffiliate)}
                  </>
                )}
              </div>
            </div>
            <WidgetByline data={article?.bylineList} />
            {article?.tags?.length > 0 && <WidgetTags id='read-complete' tags={article?.tags} />}
            {/* ------------ Ads : infinities -------------- */}
            {article?.is_show_ads && !isEmpty(ads) && generateAdConfig('native-below-article-mobile', ads) ? (
              <div className='inarticle-3 mt-3 mobile-only' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
                {article?.is_show_ads && !isEmpty(ads) && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: generateAdConfig('native-below-article-mobile', ads)
                    }}
                  />
                )}
              </div>
            ) : (
              <div className='mt-3 mobile-only ' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
                {!arrayEmpty(lastNews) ? (
                  <Carousels showDots={true} autoPlay={false} responsiveShow={1}>
                    {!arrayEmpty(lastNews) &&
                      lastNews.map((item, index) => (
                        <div key={index} className='card-carousel'>
                          <CardH
                            withTarget={true}
                            external={false}
                            data={item}
                            path={item.link}
                            loading='lazy'
                            eventDataLayer={{
                              type: DATALAYER_TYPE.TRACK_POSITION,
                              router: router?.pathname,
                              section: 'Latest News',
                              position: 'ใต้:แชร์ข่าว',
                              data: {
                                block: '1',
                                title: item?.title,
                                heading: 'Latest News',
                                carousel: index + 1
                              }
                            }}
                          />
                        </div>
                      ))}
                  </Carousels>
                ) : null}
              </div>
            )}
            {/* <div className='mt-3'>
              {article?.is_show_ads && !isEmpty(ads) && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: generateAdConfig('native-below-article-mobile', ads)
                  }}
                />
              )}
            </div> */}
            <div className='mt-3' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
              {article?.is_show_ads && !isEmpty(ads) && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: generateAdConfig('native-below-article', ads)
                  }}
                />
              )}
            </div>
            {article?.is_show_ads && <AdsNative data={dataAdsNative} isShowAds={article?.is_show_ads} />}
            {article?.is_show_ads && !isEmpty(ads) && (
              <div id='postartice' className='ads-sticky-overflow' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0)' : '' }}>
                <DynamicAds position={KEY_ADS_POSITION.POSTARTICLE} data={ads} />
              </div>
            )}
          </div>
          <div className='block-2'>
            {!isMb && (
              <>
                <StickyBox offsetTop={70} offsetBottom={70}>
                  {article?.is_show_ads && !isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.STICKY_1} data={ads} />}
                  {article?.is_show_ads && !isEmpty(ads) && generateAdConfig('native-right-stream-desktop', ads) ? (
                    <div
                      style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}
                      dangerouslySetInnerHTML={{
                        __html: generateAdConfig('native-right-stream-desktop', ads)
                      }}
                    />
                  ) : (
                    <div style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
                      <WidgetHeading heading='Latest News' />
                      {!Array.isArray(lastNews) && lastNews.length < 1 ? (
                        <div className='no-article'>
                          <img className='--side' src={`${APP_IMG}/no-article.png`} alt='no-article' width='100%' loading='lazy' />
                        </div>
                      ) : (
                        <ul className='block-list'>
                          {lastNews.slice(0, 4).map((item, index) => (
                            <li key={index}>
                              <CardH
                                data={item}
                                large={false}
                                showPublishDate={true}
                                loading='lazy'
                                //! DATALAYER
                                eventDataLayer={{
                                  type: DATALAYER_TYPE.TRACK_POSITION,
                                  router: router?.pathname,
                                  section: 'Latest News',
                                  position: 'ใต้:โฆษณาตำแหน่ง Sticky Box',
                                  data: {
                                    block: '2',
                                    title: item?.title,
                                    heading: 'Latest News',
                                    index: index + 1
                                  }
                                }}
                              />
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  )}

                  {article?.is_show_ads && !isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.STICKY_2} data={ads} />}
                </StickyBox>
              </>
            )}
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
};

export default ArticleDefault;
const SectionWrapper = styled.div`
  /* COMMEMORATE: หยดเฉพาะ media ใน card-feature เพราะใส่ filter ที่ .card-feature ตรงๆ ไม่ได้
     (ข้างในมี widget แปลภาษา/แชร์ ที่เป็น position: fixed บนมือถือ) */
  ${SHOW_COMMEMORATE === 'true' ? '.card-feature .resolution-image, .card-feature .embed-responsive,.card-feature .embed-dailymotion {  filter: grayscale(0.7); }' : ''}
  @media (max-width: 768px) {
    .container {
      padding-right: 0px;
      padding-left: 0px;
    }
  }
  @media (max-width: 690px) {
    .mobile-only {
      display: block;
      max-width: 90vw !important;
    }
    .desktop-only {
      display: none;
    }
  }
  @media (min-width: 691px) {
    .mobile-only {
      display: none;
    }
    .desktop-only {
      display: block;
    }
  }
  .hight-widget-meta-content {
    min-height: 40px;
    @media (min-width: 691px) {
      min-height: 60px;
    }
  }
  .hight-widget-meta-content-mb {
    min-height: 60px;
  }
  .article-wrapper {
    display: grid;
    grid-template-columns: 750px 1fr;
    grid-gap: 20px;
    .block-1 {
      background: linear-gradient(0deg, rgba(255, 255, 255, 1) 70%, rgba(255, 255, 255, 0) 100%);
      padding: 20px 16px;

      .article-title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin: 10px 0;
        font-size: 48px;
        font-family: 'DBHelvethaicaXBd', sans-serif !important;
        line-height: 1.15;
        font-weight: 500;
        color: var(--primary-gray);
        -webkit-line-clamp: initial;
        @media (min-width: 767px) {
          min-height: 100px;
        }
        @media (max-width: 767px) {
          font-size: 32px;
          justify-content: center;
          min-height: 100px;
        }
      }
    }
    .mt-3 {
      margin-top: 1.5rem;
    }
    .byline {
      color: #a3a3a3;
      font-size: 20px;
      margin: 10px 0;
      @media (max-width: 767px) {
        text-align: center;
      }
    }
    .card-feature {
      max-width: 100%;
      overflow-x: visible;
      overflow-y: visible;
    }
    .card-feature .resolution-image {
      display: block;
      width: 100%;
      max-width: 100%;
    }
    .card-feature .resolution-image img {
      display: block;
      width: 100% !important;
      max-width: 100% !important;
      height: auto !important;
    }
    .card-feature .embed-responsive {
      max-width: 100%;
    }
    .card-feature iframe {
      display: block;
      width: 100% !important;
      max-width: 100%;
    }
    .block-2 {
      padding-top: 30px;
      .widget-heading {
        .heading {
          font-weight: 400;
          color: var(--primary-gray);
          background-color: var(--background-color);
        }
      }
      ul.block-list {
        margin-top: 20px;
        list-style-type: none;
        padding: 0;
        li {
          margin-bottom: 20px;
          .card-h-thumb,
          .card-h-thumb img {
            border-radius: 8px;
          }
          .card-h-content-title {
            font-size: 18pt;
            line-height: 1.15;
            font-weight: 400;
            color: var(--primary-gray);
          }
        }
      }
    }

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      .block-1 {
        /* padding: 10px; */
        overflow-x: hidden;
        width: 100%;
      }
    }
  }
  .content-blurb {
    background-color: var(--blockquote-color);
    border: 1px solid var(--border-blue);
    box-shadow: 0 0 5px 0 var(--border-blue);
    border-radius: 5px;
    font-family: 'Sarabun', sans-serif;
    font-size: 20px;
    line-height: 1.55;
    font-weight: 600;
    padding: 20px;
    margin: 30px 0;
    color: var(--secondary-blue);
    blockquote {
      margin: 0;
    }
  }

  /* ใน styled-component ของ ArticleDefault */

  @media (max-width: 768px) {
    .ads-inarticle-1,
    .ads-inarticle-2,
    .ads-inarticle-3 {
      margin-left: -22px;
      margin-right: -22px;
      width: 100vw;
      max-width: 100vw;
      overflow: hidden;
      background: rgb(245, 245, 245);
    }
  }

  .content-detail {
    font-weight: 300;
    margin-bottom: 15px;
    line-height: 1.85;
    word-break: break-word;
    color: var(--text-color);
    // & > ul {
    //   margin-top: 15px;
    // }
    p {
      margin: 14px 0px;
    }
    h2 {
      position: relative;
      display: block;
      margin: auto;
      font-size: 20pt;
      font-weight: 500;
      color: var(--secondary-blue);
      /* padding: 15px 0; */
      line-height: 1.35;
      margin-left: 15px;
      @media (max-width: 475px) {
        padding-left: 5px;
      }
    }
    h2::before {
      content: '';
      display: block;
      width: 8px;
      height: 8px;
      background-color: var(--secondary-blue);
      border-radius: 50%;
      position: absolute;
      top: 19px;
      left: -20px;
      transform: translateY(-50%);

      @media (max-width: 768px) {
        left: -17px;
      }
      @media (max-width: 690px) {
        left: -15px;
      }
      @media (max-width: 475px) {
        left: -10px;
      }
    }
    p,
    strong,
    span,
    em,
    a,
    h1,
    h3,
    h4,
    h5,
    ul,
    li {
      /* color: var(--text-color); */
      font-size: 18px !important;
      font-family: 'Sarabun', sans-serif !important;
    }

    li {
      max-width: 800px;
      @media (max-width: 475px) {
        max-width: 300px;
      }
    }

    strong {
      font-weight: 700;
    }

    img {
      width: 100% !important;
      max-width: 700px !important;
      height: auto !important;
    }

    blockquote > p,
    blockquote > span,
    blockquote > strong,
    blockquote > ul {
      background: aliceblue;
      color: #4242b3 !important;
      padding: 30px;
      margin: 10px;
      border-left: 5px solid #479be4;
      font-style: italic;
      font-weight: 400;
      @media (max-width: 768px) {
        padding: 15px 20px;
      }
    }

    blockquote > p span,
    blockquote > p strong {
      color: #4242b3 !important;
      font-size: 20px !important;
    }

    blockquote > ul {
      padding-left: 40px;

      @media (max-width: 768px) {
        padding-left: 40px;
      }
    }

    p {
      span {
        img {
          width: 100%; //important
          margin: 15px auto;
          display: block;
          max-width: 100% !important;

          @media (max-width: 767px) {
            width: 100% !important;
            height: auto !important;
          }
        }
      }
    }

    p {
      img {
        display: block;
        height: auto !important;
        width: auto !important;
        margin: 10px auto !important;
        max-width: 100% !important;
        max-height: 600px !important;
      }
    }

    p > picture > img {
      display: block;
      height: auto !important;
      width: auto !important;
      margin: 10px auto !important;
      max-width: 100% !important;
      max-height: 600px !important;
    }

    a {
      color: #2980b9 !important;
      span {
        color: #2980b9 !important;
      }
      &:hover {
        color: #185985 !important;
        span {
          color: #185985 !important;
        }
      }
    }

    iframe {
      display: block !important;
      position: relative !important;
      margin: 15px auto !important;
      width: 100% !important;
      height: 100% !important;
      min-height: 315px !important;
      max-width: 560px !important;
      max-height: 315px;
      // max-width: 100% !important;

      @media (max-width: 540px) {
        min-height: 200px !important;
      }
    }

    picture {
      span {
        position: relative;
        background-color: $main-color;
        border-radius: 0px 0px 10px 10px;
        color: #fff;
        display: block;
        width: 100%;
        padding: 5px 10px;
        padding-right: 25px !important;
        font-size: 14px;
        margin: -10px auto 15px 0px;
        line-height: 1.6;
      }
    }

    .image-caption {
      font-weight: 400;
      font-size: 13px !important;
      font-style: italic;
      letter-spacing: 0px;
    }

    // iframe dailymotion start
    div[style='position:relative;padding-bottom:56.25%;height:0;overflow:hidden;'] > iframe {
      display: block;
      position: relative !important;
      margin: 20px auto !important;
      max-width: 100% !important;
      height: 420px;
      @media (max-width: 767px) {
        height: 210px !important;
      }
    }
    div[style='position:relative;padding-bottom:56.25%;height:0;overflow:hidden;'] {
      height: 420px !important;
      margin: 20px auto;
      @media (max-width: 767px) {
        height: 210px !important;
      }
    }
    // iframe dailymotion end
  }
  .related-news-desktop {
    width: 420px;
    margin: auto;
    min-height: unset;
    max-width: 100%;
    @media (max-width: 767px) {
      width: unset;
    }
    // @media (max-width: 767px) {
    //   margin: -40px auto -10px auto;
    // }
  }
`;
